import React, { createContext } from 'react';
import { INITIAL_VALUE } from './constants';

export const DocumentationViewContext = createContext(INITIAL_VALUE);

const DocumentationViewContextProvider = ({
    shouldShowTgssConsent,
    shouldShowQRPage,
    isDocumentRetryBeenShown,
    children,
}) => {
    return (
        <DocumentationViewContext.Provider
            value={{ shouldShowTgssConsent, shouldShowQRPage, isDocumentRetryBeenShown }}
        >
            {children}
        </DocumentationViewContext.Provider>
    );
};

export default DocumentationViewContextProvider;
